import { useContext } from "react";
import CurrentUserContext from "./context";

const useCurrentUser = () => {
    return useContext(CurrentUserContext);
};

export default useCurrentUser;
